<template>
  <div>
    <b-row>
      <b-col cols="12" xl="8">
        <div class="form-container separator">

          <pcg-text-input class="col-12"
                          :label="$t('views.dictionary_acceptance_words.labels.name')"
                          :error-text="getError('name')"
                          :show-error="errorExist('name')"
                          v-model="dictionaryWord.name"/>
          <pcg-text-input class="col-12" type="textarea"
                          :required="true"
                          :label="$t('views.dictionary_acceptance_words.labels.value')"
                          :error-text="getError('value')"
                          :show-error="errorExist('value')"
                          v-model="dictionaryWord.value"/>
          <pcg-checkbox class="col-12"
                        :error-text="getError('status')"
                        :show-error="errorExist('status')"
                        v-model="dictionaryWord.statusBoolean">
            {{$t('views.dictionary_acceptance_words.labels.status')}}
          </pcg-checkbox>
          <pcg-btn v-if="dictionaryWord" size="small" @click="updateDictionaryAcceptanceWord()" variant="additional" class="action-btn">
            {{ $t('views.common.save') }}
          </pcg-btn>
        </div>
      </b-col>
    </b-row>

  </div>
</template>

<script>
import ApiDictionaryAcceptanceWords from '../../api/dictionary_acceptance_words'

export default {
  name: 'DictionaryAcceptanceWordsEdit',
  components: {
  },
  data () {
    return {
      dictionaryId: this.$route.params.dictionaryId,
      id: this.$route.params.id,
      errors: {},
      dictionaryWord: {
        value: null,
        status: null,
        statusBoolean: null
      }
    }
  },
  mounted () {
    window.scrollTo({ left: 0, top: 0, behavior: 'smooth' })
    this.getDictionaryAcceptanceWord()
  },
  methods: {
    getDictionaryAcceptanceWord () {
      ApiDictionaryAcceptanceWords.getDictionaryAcceptanceWord(this.dictionaryId, this.id)
        .then(response => {
          // console.log(JSON.stringify(response.data.data))
          this.dictionaryWord = response.data.data.attributes
          if (this.dictionaryWord.status === 'required') {
            this.dictionaryWord.statusBoolean = true
          } else {
            this.dictionaryWord.statusBoolean = false
          }
        }).catch(error => {
          this.$toastr.e(error)
          console.log(error)
        })
    },
    setHeader () {
      this.$store.dispatch('header/setHeader', {
        title: this.$t('views.dictionary_acceptance_words.edit.title'),
        subtitle: this.$t('views.dictionary_acceptance_words.edit.subtitle'),
        capitalizeSubtitle: false
      })
    },
    updateDictionaryAcceptanceWord () {
      this.loading = true
      const dictionaryWordDup = this.dictionaryWord
      if (this.dictionaryWord.statusBoolean) {
        dictionaryWordDup.status = 'required'
      } else {
        dictionaryWordDup.status = 'optional'
      }
      ApiDictionaryAcceptanceWords.updateDictionaryAcceptanceWord(this.dictionaryId, this.id,
        { dictionaryAcceptanceWord: dictionaryWordDup })
        .then(response => {
          this.errors = {}
          this.getDictionaryAcceptanceWord()
          setTimeout(() => { this.$toastr.s(this.$t('general.dictionary_word_updated')) }, 1)
        }).catch(error => {
          this.errors = error.response.data
          setTimeout(() => { this.$toastr.e(this.$t('general.check_errors')) }, 1)
        }).finally(() => {
          this.loading = false
        })
    },
    getError (field) {
      if (this.errorExist(field)) {
        return this.errors[field].join(', ')
      }
      return ''
    },
    errorExist (field) {
      return !!(this.errors && this.errors[field])
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.setHeader()
    })
  }
}
</script>
